const deductionErrorMessages: Record<string, string> = {
  MO0024: 'This deduction would refund an online payment after delivery.',
  MO0025: 'Confirm that the driver collected the adjusted amount from the customer.'
}

export function getDeductionErrorMessage(
  errorCode?: string | null,
  fallbackMessage?: string | null
) {
  return (
    fallbackMessage ||
    (errorCode ? deductionErrorMessages[errorCode] : undefined) ||
    'Unable to update the deduction.'
  )
}

export function getOrderDeductionError(error: unknown) {
  const candidate = (error ?? {}) as {
    body?: unknown
    response?: { data?: unknown }
    message?: string
  }
  const body = (candidate.body ?? candidate.response?.data ?? candidate) as {
    errorCode?: string | null
    message?: string | null
    detail?: string | null
  }

  return {
    error: true as const,
    errorCode: body.errorCode,
    message: body.message ?? body.detail ?? candidate.message
  }
}
